import ApiClient from '@/services/apiClient';

// SPC intrusion panel configuration of a LINK, same fields as the Haxo Setup app
export default class SpcConfig {
    receiver_id;
    id;
    serial;
    spt_account;
    aes_key;
    aes_iv;
    username;
    password;
    access_control;   // SPC access control (HAXO Fusion): the panel's doors become readers of the LINK

    static constructFromObject(data, obj) {
        obj = obj || new SpcConfig();
        if (data) {
            obj.receiver_id = ApiClient.convertToType(data['receiver_id'], 'Integer') ?? 0;
            obj.id = ApiClient.convertToType(data['id'], 'String') ?? '';
            obj.serial = ApiClient.convertToType(data['serial'], 'Integer') ?? null;
            obj.spt_account = ApiClient.convertToType(data['spt_account'], 'Integer') ?? null;
            obj.aes_key = ApiClient.convertToType(data['aes_key'], 'String') ?? '';
            obj.aes_iv = ApiClient.convertToType(data['aes_iv'], 'String') ?? null;
            obj.username = ApiClient.convertToType(data['username'], 'String') ?? '';
            obj.password = ApiClient.convertToType(data['password'], 'String') ?? '';
            obj.access_control = ApiClient.convertToType(data['access_control'], 'Boolean') ?? false;
        }
        return obj;
    }

    toJSON() {
        const json = {
            receiver_id: this.receiver_id,
            id: this.id,
        };
        if(this.serial != null) json.serial = this.serial;
        if(this.spt_account != null) json.spt_account = this.spt_account;
        json.aes_key = this.aes_key;
        if(this.aes_iv) json.aes_iv = this.aes_iv;
        json.username = this.username;
        json.password = this.password;
        json.access_control = this.access_control === true;
        return json;
    }
}
